module.exports = __webpack_public_path__ + "media/images/pic/brodno/offer/equipment-82b911f4a3c0ba69e23f33e61ec01d9a.jpg";